export default __webpack_public_path__ + "static/veeam-1cd08b7cede49939a5656f6b58188621.png";